import { useState } from 'react';
import type { ComponentContentSchema } from '@vibesites/runtime';
import {
  useBlockSlot,
  SectionContextProvider,
  EditableToken,
} from '@vibesites/runtime/react';

export function ApartmentSyncSection() {
  const [mapArmed, setMapArmed] = useState(false);
  const blockSlot = useBlockSlot('apartmentsyncsection.block', {
    defaultValue: 'apartment-sync',
  });

  return (
    <section
      className={`apartment-sync-section${mapArmed ? '' : ' map-scroll-block'}`}
      onMouseLeave={() => setMapArmed(false)}
    >
      <EditableToken path="apartmentsyncsection.block" as="div">
        {blockSlot ? (
          <SectionContextProvider sectionId={blockSlot.sectionId}>
            <blockSlot.BlockComponent sectionId={blockSlot.sectionId} />
          </SectionContextProvider>
        ) : (
          <div className="apartment-sync-empty">No block selected</div>
        )}
      </EditableToken>
      {!mapArmed && (
        <button
          type="button"
          className="apartment-sync-arm"
          aria-label="Click to interact with the map"
          onClick={() => setMapArmed(true)}
        />
      )}
      <style>{`
        .apartment-sync-section {
          position: relative;
          width: 100%;
        }
        .apartment-sync-empty {
          font-family: var(--vibe-font-body);
          color: var(--vibe-color-text-muted);
          text-align: center;
          padding: 2rem 1rem;
        }
        .apartment-sync-arm {
          position: absolute;
          inset: 0;
          z-index: 10;
          border: 0;
          background: transparent;
          cursor: pointer;
        }
        .map-scroll-block iframe { pointer-events: none !important; }
      `}</style>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'ApartmentSyncSection',
  displayName: 'Apartment Sync Section',
  tokens: {
    'apartmentsyncsection.block': {
      label: 'Block',
      type: 'block',
      defaultValue: 'apartment-sync',
      acceptedBlockCategories: ['Integrations'],
    },
  },
};

(ApartmentSyncSection as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default ApartmentSyncSection;
